import React, { useState } from 'react';

 const tagColors = [
    'bg-blue-100 text-blue-800', 
    'bg-green-100 text-green-800', 
    'bg-purple-100 text-purple-800', 
    'bg-yellow-100 text-yellow-800', 
    'bg-red-100 text-red-800'
  ];
const ReportSectionInput = ({ field, formData, setFormData, isSubmitting }) => {
  const [currentInput, setCurrentInput] = useState('');

  // Initialize the field as an array if it doesn't exist
  if (!formData[field.name]) {
    setFormData(prev => ({
      ...prev,
      [field.name]: []
    }));
  }

  const handleInputChange = (e) => {
    setCurrentInput(e.target.value);
  };

  const handleAddSection = () => {
    const newSection = currentInput.trim();
    if (newSection && !formData[field.name].includes(newSection)) {
      setFormData(prev => ({
        ...prev,
        [field.name]: [...prev[field.name], newSection]
      }));
      setCurrentInput('');
    }
  };

  const handleRemoveSection = (sectionToRemove) => {
    setFormData(prev => ({
      ...prev,
      [field.name]: prev[field.name].filter(section => section !== sectionToRemove)
    }));
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleAddSection();
    }
  };

  return (
    <div className="w-full">
      {/* Input field with Add button */}
      <div className="flex items-center gap-2 mb-2">
        <input
          type="text"
          value={currentInput}
          onChange={handleInputChange}
          onKeyPress={handleKeyPress}
          className="flex-1 border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#bb1ccc] focus:border-[#bb1ccc] placeholder-gray-500"
          placeholder={field.placeholder || "Enter report section and press Enter or click Add"}
          disabled={isSubmitting}
        />
        <button
          type="button"
          onClick={handleAddSection}
          className="px-4 py-2 bg-[#bb1ccc] text-white rounded-md hover:bg-[#000080] disabled:opacity-50 disabled:cursor-not-allowed"
          disabled={isSubmitting || !currentInput.trim()}
        >
          Add
        </button>
      </div>

      {/* Display added sections as colored tags */}
      <div className="flex flex-wrap gap-2 mb-2">
        {formData[field.name] && formData[field.name].map((section, index) => (
          <span
            key={section}
            className={`${tagColors[index % tagColors.length]} px-3 py-1 rounded-full text-sm flex items-center gap-1`}
          >
            {section}
            <button
              type="button"
              onClick={() => handleRemoveSection(section)}
              className="ml-1 text-inherit hover:text-[#000080] focus:outline-none"
              disabled={isSubmitting}
            >
              &times;
            </button>
          </span>
        ))}
      </div>
    </div>
  );
};

export default ReportSectionInput;